module.exports = ".card1{\r\n    height: 450px;\r\n    border: 1px solid gray;\r\n    border-radius: 5px;\r\n    -webkit-box-shadow: 3px 4px 5px 1px rgba(0, 0, 0, 0.38);\r\n            box-shadow: 3px 4px 5px 1px rgba(0, 0, 0, 0.38);\r\n    margin-top: 2em;\r\n    margin-bottom: 1em;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/reports-dashboard/dashboard/dashboard.component.css
// module id = ./src/app/admin/reports-dashboard/dashboard/dashboard.component.css
// module chunks = main